import React from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';

const ResetSent = ({ email, onSwitchToLogin }) => {
  const { t } = useLanguage();
  return (
    <Card className="auth-card" style={{ maxWidth: '450px', width: '100%' }}>
      <Card.Body className="p-4 p-md-5 text-center">
        <div className="icon-circle bg-success bg-gradient mx-auto mb-3">
          <i className="bi bi-envelope text-white"></i>
        </div>
        <h2 className="fw-bold">{t('resetSent.title')}</h2>
        <p className="text-muted">{t('resetSent.message')}</p>
        <p className="text-primary fw-semibold mb-4">{email}</p>

        <Alert variant="info" className="text-start">
          <div className="d-flex">
            <i className="bi bi-info-circle-fill me-2 mt-1"></i>
            <div>
              {t('resetSent.info')}
            </div>
          </div>
        </Alert>

        <hr className="my-4" />

        <Button variant="link" className="p-0 link-primary" onClick={onSwitchToLogin}>
          <i className="bi bi-arrow-left me-2"></i>
          {t('resetSent.backToLogin')}
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ResetSent;
